<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}
      </div>
      <div>
        <router-link
          v-if="$can('update', 'Raw Material Category')"
          class="btn-blue"
          :to="'edit-raw-material-categories/?rmc_id=' + rmc_id"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="raw-materials-categories"
          >{{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}
          {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ rmc_category }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div
                v-if="rmc_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("active") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("inactive") }}
              </div>
            </div>
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ updated_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import { BASEURL } from "@/config/index.js";

export default {
  components: { Multiselect },
  data() {
    return {
      rmc_category: "",
      rmc_is_active: true,
      rmc_id: "",
      created_at: "",
      created_by: "",
      updated_by: "",
      updated_at: "",
      URL_BASE: BASEURL,
    };
  },
  beforeMount() {
    this.rmc_id = this.$route.query.rmc_id;
  },
  mounted() {
    this.getVendorsList();
  },
  methods: {
    getVendorsList: function () {
      let payload = {
        tableName: "ms_raw_material_category",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.ms_food_categories = data.Records;
            data.Records.map((x) => {
              if (this.rmc_id == x.rmc_id) {
                this.rmc_category = x.rmc_category;
                this.rmc_is_active = x.rmc_is_active;
                this.created_at = x.created_at;
                this.updated_at = x.updated_at;
                this.fc_icon_url = x.fc_icon_url;
                this.getViewUsersDetails(x.created_by, "created_by");
                this.getViewUsersDetails(x.updated_by, "updated_by");
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/viewRawMaterialCategories.vue